import { Link, NavLink } from "react-router-dom";
import { Logout } from "../../../utils/Logout";

const OfHeader = ({ bar, me, setSearch, geolocation, setGeolocation, provincias, onClick, getParams, navigate }) => {
  return (
    <div
      className="offcanvas offcanvas-top min-vh-100"
      tabindex="-1"
      id="offcanvasTop-header"
      aria-labelledby="offcanvasTopLabel"
    >
      <div className="offcanvas-header py-1">
        <h5
          className="offcanvas-title Grifter"
          id="offcanvasTopLabel-header"
          style={{ fontSize: "12px" }}
        >
          <img src="/assets/img/marca/antesala-logo.svg" width="100px" alt="" />
        </h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div className="offcanvas-body">
        <div className="container-md">
          <ul className="col-md-6 navbar-nav justify-content-start align-items-center  mb-2 mb-lg-0 w-full border-0">
            {bar.map((menu) => {
              if (menu.dropdown) {
                return (
                  <li
                    className={`w-100 mx-2 nav-item dropdown text-start mb-2 ${
                      menu.show ? "" : "d-none"
                    }`}
                  >
                    <a
                      className="nav-NavLink dropdown-toggle fs-5 text-dark fw-bold"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {menu.name}
                    </a>
                    <ul className="dropdown-menu">
                      {menu.dropdown.map((submenu) => {
                        return (
                          <li>
                            <Link
                              className="dropdown-item fs-7 text-dark fw-bold"
                              to={submenu.link}
                            >
                              {submenu.name}
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </li>
                );
              } else {
                return (
                  <li
                    className={`w-100 mx-2 nav-item text-start mb-2 ${
                      menu.show ? "" : "d-none"
                    }`}
                  >
                    <Link
                      className="nav-NavLink active fs-5 text-dark fw-bold"
                      to-current="page"
                      to={menu.link}
                    >
                      {menu.name}
                    </Link>
                  </li>
                );
              }
            })}
          </ul>

          <div className="col-md-6 d-md-flex justify-content-center align-items-center d-block">
            <div className="d-flex mb-2 w-100">
              <input
                className="form-control border border-dark py-1"
                style={{ borderRadius: "10px 0px 0px 10px" }}
                type="search"
                placeholder="Buscar"
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") onClick({target: {name: "search"}});
                }}
              />
              <label
                className="btn btn-dark border-0 py-1"
                style={{ borderRadius: "0px 10px 10px 0px" }}
              >
                <i className="bi bi-search"></i>
                <button
                  className="d-none"
                  name="search"
                  onClick={(e) => onClick(e)}
                ></button>
              </label>
            </div>

            <div className="dropdown mb-2 w-100">
              <button
                className="btn btn-outline-dark dropdown-toggle w-100 py-1"
                style={{ borderRadius: "10px" }}
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {geolocation}
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton1"
              >
                {provincias.map((provincia) => (
                  <li>
                    <label className="dropdown-item">
                      {provincia.provincia}
                      <button
                        className="d-none"
                        onClick={() =>{
                          localStorage.setItem(
                            "geolocation",
                            provincia.provincia
                          )
                          getParams.set('provincia', provincia.provincia);
                          navigate(`?${getParams.toString()}`);
                          setGeolocation(provincia.provincia)
                          window.location.reload();
                        }}
                      ></button>
                    </label>
                  </li>
                ))}
              </ul>
            </div>

            {me ? (
              <div className="dropdown mx-md-2 mb-2">
                <button
                  className="btn btn-outline-dark dropdown-toggle  w-100"
                  style={{ borderRadius: "20px" }}
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span>{`${me.nombre} ${me.apellido}`}</span>
                </button>
                <ul className="dropdown-menu">
                  <li
                    className={`${
                      me.roles[0].nombre == "adm" ||
                      me.roles[0].nombre == "prd" ||
                      me.roles[0].nombre == "sala"
                        ? ""
                        : "d-none"
                    }`}
                  >
                    <a
                      className="btn btn-outline-dark w-100 border-0 text-start"
                      href={"/dashboard/perfil"}
                    >
                      Administrador
                    </a>
                  </li>
                  <li>
                    <button
                      className="btn btn-outline-dark w-100 border-0 text-start"
                      type="button"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasTop-membresia"
                      aria-controls="offcanvasTop-membresia"
                    >
                      Membresias
                    </button>
                  </li>
                  <li>
                    <button
                      className="btn btn-outline-dark w-100 border-0 text-start"
                      type="button"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasTop-entradas"
                      aria-controls="offcanvasTop-entradas"
                    >
                      Entradas
                    </button>
                  </li>
                  <li>
                    <label className="btn btn-outline-dark w-100 border-0 text-start w-100">
                      Cerrar Sesion
                      <button
                        className="d-none"
                        onClick={(e) => Logout()}
                      ></button>
                    </label>
                  </li>
                </ul>
              </div>
            ) : (
              <div>
                <label
                  className="btn btn-outline-dark d-flex align-items-center py-1 px-1"
                  style={{ borderRadius: "10px", maxHeight: "35px" }}
                >
                  <i className="rounded-pill bi bi-person-circle fs-4 me-1"></i>
                  <span className="Grifter" style={{ fontSize: "12px" }}>
                    INGRESAR
                  </span>
                  <button
                    className="d-none"
                    name="login"
                    onClick={(e) => onClick(e)}
                  ></button>
                </label>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfHeader;
